import { render } from 'preact';
import { App } from './ui/App.js';
import { boot, openChat } from './lib/engine.js';
import './styles.css';

/**
 * Регистрация Service Worker.
 *
 * Без неё не будет ни пушей, ни офлайна: подписка на Web Push существует
 * только у зарегистрированного воркера. Делаем это до первой отрисовки,
 * но не ждём завершения — приложение должно открыться и без него.
 */
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js', { type: 'module' }).catch((error) => {
    console.error('не удалось зарегистрировать service worker:', error);
  });

  // Клик по уведомлению, когда вкладка уже открыта: воркер не может сменить
  // в ней адрес, поэтому просто сообщает, какой чат нужно показать.
  navigator.serviceWorker.addEventListener('message', (event) => {
    const data = event.data as { type?: string; chatId?: string };
    if (data?.type === 'open-chat' && data.chatId) void openChat(data.chatId);
  });
}

render(<App />, document.getElementById('app')!);

void boot().catch((error) => {
  console.error('не удалось восстановить сессию:', error);
});
